import { render, staticRenderFns } from "./PlanPurchaseCard.vue?vue&type=template&id=46a20554&scoped=true&"
import script from "./PlanPurchaseCard.vue?vue&type=script&lang=js&"
export * from "./PlanPurchaseCard.vue?vue&type=script&lang=js&"
import style0 from "./PlanPurchaseCard.vue?vue&type=style&index=0&id=46a20554&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a20554",
  null
  
)

export default component.exports